/**
 * AOS Animation library
 */
 import AOS from 'aos';
 import 'aos/dist/aos.css';
 AOS.init();

 /**
 *  Masonry
 */
import Masonry from 'masonry-layout'
var imagesLoaded = require('imagesloaded');

$(function () {
    /**
     * Primary Nav
     */
    $('.hamburger').on('click', function(e) {
        $('.hamburger').toggleClass('is-active');
        $('.main-menu').toggleClass('is-active');
        $('html').toggleClass('no-scroll');
    })

    
    $('.hasSubNav .sectionNav, .topLevel a').on('click touchstart', function(e) {
        if(!$(this).parent().hasClass('sub-open')) {
            $('.hasSubNav').removeClass('sub-open');
        }
        if($(this).parent().hasClass('hasSubNav')) {
            $(this).parent().toggleClass('sub-open');
        }
    })

    /**
     * Best price popuut
     */
     $('.bp-nav').on('click', function(e) {
        $('.best-price').toggleClass('bp-open');
    })


    /**
     * Cookie policy
     */
    // Check for cookie
    var cp = Cookies.get('cookiepolicy')
    
    if(!cp) {
        $('.cookie-policy').addClass('show-cookie-policy')
    }

    // Accept non-esential cookies
    $('.hideCookiePolicy').on('click', function() {
        Cookies.set('cookiepolicy', 1, { expires: 180 })
        window.dataLayer.push({
            'event': 'consented',
        })
        $('.cookie-policy').hide()
        if(window.location.pathname == '/manage-cookies') {
            history.back()
        }
    })

    // Decline non-esential cookies
    $('.declineNonEssentialCookies').on('click', function() {
        Cookies.set('cookiepolicy', 0, { expires: 180 })
        $('.cookie-policy').hide()
        if(window.location.pathname == '/manage-cookies') {
            history.back()
        } else {
            location.replace('/')
        }
    })
    
    $('.plus').on('click', function() {
        $('header').toggleClass('is-active');
        $('body').toggleClass('no-scroll');
    })

    /**
     * Signup modal
     */
    // Check for cookie
    var sup = Cookies.get('signupCookie')
    if(sup) {
        $('#signup-sideout').addClass('sideout-blocked')
    }
    // close
    $('#signup-sideout .close').on('click', function(e) {
        $('#signup-sideout').addClass('sideout-hide')
    })

    // hide forever
    $('#hideForever').on('click', function(e) {
        $('#signup-sideout').addClass('sideout-hide')
        Cookies.set('signupCookie', true)
    })

    // Popup on load modal component
    var popupNoticeElement = document.getElementById('popupNotice')
    if(popupNoticeElement) {
        var popupNotice = new bootstrap.Modal(popupNoticeElement)
        popupNotice.show()
    }

    // Popup on load Offer component
    var popupOfferElement = document.getElementById('popupOffer')
    if(popupOfferElement) {
        var popupOffer = new bootstrap.Modal(popupOfferElement)
        popupOffer.show()
    }


    $(document).on('scroll', function () {
        var y = $(this).scrollTop();
        var endOfContent = 300
        if (y > (endOfContent)) {
            $('header').addClass('header-fixed');
        } else {
            $('header').removeClass('header-fixed');
        }

        // signup sideout
        if (y > 800) {
            $('#signup-sideout').addClass('sideout-show')
            //$(window).off('scroll');
        }
    });

   
    /**
     * Analytics and FB Events 
     */

    // Phone Click
    $('.phoneClick').on('click', function(e) {
        if("ga" in window) {
            var tracker = ga.getAll()[0];
            tracker.send('event', 'lead-Phone', 'Click', 'Header')

            fbq('trackCustom', 'LeadPhone');
        }
    })

    // image modal
    $('.masonry-item').on('click', function() {
        var imageSrc = $(this).find('img').attr('src');
        $('.js-modal-image').attr('src', imageSrc);

        var galleryModal = new bootstrap.Modal(document.getElementById('galleryModal'), {
            keyboard: false
          })
        
        galleryModal.show()
    });

    // Initialize Slick
    $('.slickInit').slick()

    if($('.masonry').length) {
        // Initiate Masonry Gallery
        imagesLoaded( '.masonry', function() {
            // images have loaded
            var grid = new Masonry( '.masonry', {
                // options
                itemSelector: 'li',
                columnWidth: 'li',
                percentPosition: true
            });
        });
    }
});


/**
 * Recaptcha
 */
 window.getRecaptchaToken = function () {
    return new Promise(function(resolve, reject) {
        grecaptcha.ready(function() {
            grecaptcha.execute('6Ld0k34fAAAAAOa3CEFDkrn3ipi7V-J_A0gFjalP', {action: 'subscribe'}).then(function(token) {
                resolve(token)
            });
        });
    });
}